import React, { useEffect } from 'react';
import 'react-image-gallery/styles/css/image-gallery.css';
import UserImage from '../../../../../assets/images/common/Icons/User.png';
import UserBlueIcon from '../assets/images/user_blue_icon.png';
import UserDoubleBlueIcon from '../assets/images/user_double_blue_icon.png';
import UserRedIcon from '../assets/images/red.png';

import { Cell } from 'react-sticky-table';
import { useGlobalState } from './GlobalState';

export const addToDateString = (strDate, daysAmount) => {
  const d = new Date(strDate);
  const d2 = new Date(new Date().setDate(d.getDate() + daysAmount));
  return d2.toISOString().split('T')[0];
};

export default function SelectSwim(props) {
  const [, setUserSelectedGuests] = useGlobalState('userSelectedGuests');

  const [swimAvailableData] = useGlobalState('swimAvailableData');

  const [anglers] = useGlobalState('anglers');
  const [unSelectableSwimIds] = useGlobalState('unSelectableSwimIds');

  // user selected swims
  const [userSelectedSwims, setUserSelectedSwims] =
    useGlobalState('userSelectedSwims');
  const [userSelectedDoubleSwim, setUserSelectedDoubleSwim] = useGlobalState(
    'userSelectedDoubleSwim'
  );

  const availableDSwims = swimAvailableData.double_swims;
  const selectedDates = swimAvailableData.selected_dates;

  const swim_id = props.swim_id;
  const date = props.date;
  const index = props.index;

  const handleSwimChange = (e, swim) => {
    setUserSelectedGuests(null);
    // Maintain local variables because of globalstate latency
    let local_variable_swim = userSelectedSwims;
    let local_variable_double_swim = userSelectedDoubleSwim;

    // Need not send request to API if it's a double swim
    let call_api = true;

    if (userSelectedSwims.length + userSelectedDoubleSwim.length < anglers) {
      let index = userSelectedSwims.indexOf(swim);
      if (index !== -1) {
        let dsIndex = userSelectedDoubleSwim.indexOf(swim);

        if (availableDSwims.indexOf(swim) > -1 && dsIndex === -1) {
          local_variable_double_swim = [...userSelectedDoubleSwim, swim];
          setUserSelectedDoubleSwim(local_variable_double_swim);
          call_api = false;
        } else {
          if (dsIndex > -1) {
            userSelectedDoubleSwim.splice(dsIndex, 1);
            local_variable_double_swim = [...userSelectedDoubleSwim];
            setUserSelectedDoubleSwim(local_variable_double_swim);
          }
          userSelectedSwims.splice(index, 1);
          local_variable_swim = [...userSelectedSwims];
          setUserSelectedSwims(local_variable_swim);
        }
      } else {
        local_variable_swim = [...userSelectedSwims, swim];
        setUserSelectedSwims(local_variable_swim);
      }
    } else {
      setUserSelectedSwims([]);
      setUserSelectedDoubleSwim([]);
      // local_variable_swim = [];
      // local_variable_double_swim = [];
    }

    if (call_api) {
      // sendDataToServer(local_variable_swim);
    }
  };
  useEffect(() => {
    if (
      swimAvailableData?.booked_dates[userSelectedSwims[0]]?.indexOf(
        selectedDates[0]
      ) > -1
    ) {
      setUserSelectedSwims([]);
    }
  }, [availableDSwims]);

  const handleOnclickEvent = (
    e,
    isSelectedDates,
    isUnClickable,
    swim_id,
    date
  ) => {
    if (isSelectedDates) {
      if (isUnClickable) {
      } else {
        handleSwimChange(e, swim_id, date);
      }
    }
  };
  const isSelectedDates = selectedDates.indexOf(date) !== -1;
  const isAdjacentDate =
    selectedDates.indexOf(addToDateString(date, -1)) !== -1 ||
    selectedDates.indexOf(addToDateString(date, 1)) !== -1;
  if (
    swimAvailableData.booked_dates &&
    swimAvailableData.booked_dates[swim_id] &&
    swimAvailableData.booked_dates[swim_id].indexOf(date) > -1 &&
    swimAvailableData.edited_dates &&
    swimAvailableData.edited_dates[swim_id] &&
    swimAvailableData.edited_dates[swim_id].indexOf(date) === -1
  ) {
    return (
      <Cell
        className={
          (isSelectedDates ? 'bg-swim-user-selected-range ' : '') +
          (isSelectedDates || isAdjacentDate ? 'swim-user-adjacent-range' : '')
        }
        key={index}
      >
        <div>
          <img alt={swim_id + '#' + date} src={UserRedIcon} width={15} />
        </div>
      </Cell>
    );
  } else if (
    swimAvailableData.booked_dates &&
    swimAvailableData.booked_dates[swim_id] &&
    swimAvailableData.booked_dates[swim_id].indexOf(date) > -1
  ) {
    return (
      <Cell
        className={
          (isSelectedDates ? 'bg-swim-user-selected-range ' : '') +
          (isSelectedDates || isAdjacentDate ? 'swim-user-adjacent-range' : '')
        }
        key={index}
      >
        <div>
          <img alt={swim_id + '#' + date} src={UserRedIcon} width={15} />
        </div>
      </Cell>
    );
  } else {
    const isUnClickable =
      unSelectableSwimIds && unSelectableSwimIds.indexOf(swim_id) > -1;
    const userSelectedIcon =
      userSelectedDoubleSwim.indexOf(swim_id) > -1 && isSelectedDates
        ? UserDoubleBlueIcon
        : userSelectedSwims.indexOf(swim_id) > -1 && isSelectedDates
          ? UserBlueIcon
          : UserImage;

    const userDoubleSelect =
      userSelectedDoubleSwim.indexOf(swim_id) > -1 && isSelectedDates;

    return (
      <Cell
        className={
          (isSelectedDates ? 'bg-swim-user-selected-range ' : '') +
          (isSelectedDates || isAdjacentDate ? 'swim-user-adjacent-range' : '')
        }
        key={index}
        onClick={(e) => {
          handleOnclickEvent(e, isSelectedDates, isUnClickable, swim_id, date);
        }}
      >
        <div>
          <img
            className={`${
              userDoubleSelect ? 'active-double' : ''
            } available-swim-date select-swim-user-image`}
            alt={swim_id + '#' + date}
            src={userSelectedIcon}
          />
        </div>
      </Cell>
    );
  }
}
